export default "__VITE_ASSET__751951c7__"